import { htmlFontSize } from '@bymason/runtime-config';

export function pxToRem(px: number) {
  return `${px / htmlFontSize}rem`;
}
